<!-- 套餐信息 -->
<template>
  <div class="package-info">
    <div class="top">
      <div class="title">
        <img class="hidden-sm-and-down" src="@/assets/images/visa/packageinfo-title.png" alt="" />
        <img class="hidden-sm-and-up" src="@/assets/images/visa/packageinfo-title-h5.png" alt="" />
      </div>

      <!-- 美国卡/全球卡 -->
      <div class="cardtype">
        <ul>
          <li
            v-for="(item, index) in cardTypeList"
            :key="item.id"
            :class="[{ active: activeCardType === item.value }, 'item' + index]"
            @click="activeCardType = item.value"
            @mouseenter="activeCardType = item.value">
            <img :src="activeCardType === 'USLC' ? item.imgUrl1 : item.imgUrl2" alt="" />
            <span>{{ item.name }}</span>
          </li>
        </ul>
        <h3>
          <template v-if="activeCardType === 'USLC'">
            <span>畅享无限通讯，</span>
            连接美国每一刻
          </template>
          <template v-else>
            <span>全球畅游</span>
            一卡在手，
          </template>
        </h3>
        <h4>
          {{
            activeCardType === 'USLC'
              ? '让您的美国之行通讯无忧！'
              : '让您的数据连接无国界，世界任你行！'
          }}
        </h4>
      </div>

      <div class="list">
        <div class="button-group">
          <!-- 短期差旅/长期居住 -->
          <div class="box1">
            <li
              :class="{ active: activeTime === item.value }"
              v-for="item in activeCardType === 'USLC' ? timeTypeList : simTypeList"
              :key="item.id"
              @click="activeTime = item.value"
              @mouseenter="activeTime = item.value">
              <div v-html="item.name"></div>
            </li>
            <li
              class="slider-bg hidden-sm-and-down"
              :style="{
                '--slider':
                  activeTime === 'rk_activity_10013_single' || activeTime === 'Physical SIM'
                    ? '0px'
                    : '260px'
              }"></li>
            <li
              class="slider-bg hidden-sm-and-up"
              :style="{
                '--slider':
                  activeTime === 'rk_activity_10013_single' || activeTime === 'Physical SIM'
                    ? '0px'
                    : '42.6667vw'
              }"></li>
            <!-- 实体卡和esim卡的区别 -->
            <span class="diff" v-show="activeCardType === 'GRDC'">
              {{ '实体卡和eSIM卡的区别' }}
              <el-popover placement="bottom" trigger="hover" popper-class="esim-popover">
                <i class="wenhao" slot="reference"></i>
                <div>
                  <PopoverDiffGlobal />
                </div>
              </el-popover>
            </span>
          </div>
          <h3 v-show="activeCardType === 'USLC'">
            {{
              activeTime === 'rk_activity_10013_single'
                ? '迎客移动1月套餐，专为短期出行定制。旅行、出差、探亲，通讯无忧，启程即享，精彩不断'
                : '迎客移动懂您所需，特推悠享美国“多月套餐”，为长期居住、频繁出差、探亲游学量身打造，通讯无忧，连接更紧密'
            }}
          </h3>
          <h4 v-show="activeCardType === 'GRDC'">
            <span>温馨提示：</span>
            eSIM手机卡只支持部分手机设备，请确保您的手机支持eSIM，建议您在手机品牌官网或手机设置【蜂窝移动网络】中查看确认。
          </h4>
          <!-- 长期居住 3/6/12月 -->
          <div
            class="box2"
            v-show="activeCardType === 'USLC' && activeTime === 'rk_activity_10013_multi'">
            <li
              :class="{ active: activeMonth === item }"
              v-for="item in monthList"
              :key="item"
              @click="activeMonth = item"
              @mouseenter="activeMonth = item">
              <span>{{ item }}个月</span>
            </li>
          </div>
        </div>
        <!-- 美国套餐 -->
        <template v-if="activeCardType === 'USLC'">
          <div class="bundle" :style="{ '--block': bundleDataCptd.length > 0 ? 'block' : 'none' }">
            <li
              v-for="(item, index) in bundleDataCptd"
              :key="item.rackProductId"
              @mouseenter="activeBundle = index"
              @click="activeBundle = index"
              :class="{ active: activeBundle === index }">
              <!-- <div class="label" :style="{ background: ids.color }">{{ ids.name }}</div> -->
              <div class="up">
                <h1>
                  {{ item.bundleData }}
                  <span>/{{ item.bundleDuration }}天</span>
                </h1>
                <h2>{{ item.productTitle }}</h2>
              </div>
              <div class="down">
                <h3>
                  <span>${{ item.saleUnitPrice }}</span>
                  <strong>/{{ item.bundleDuration }}天</strong>
                </h3>
                <!-- <h4
                  :style="{
                    opacity: item.saleUnitPrice * 0.8 === item.unitPrice ? 0 : 1
                  }">
                  ${{ item.unitPrice }}/{{ item.bundleDuration }}天
                </h4> -->
                <span>套餐月数：{{ item.productDuration }}个月</span>
                <el-button @click="onSubmit(item, 1)">使用满减券</el-button>
                <el-button style="margin-left: 0" class="btn-style" @click="onSubmit(item, 2)">
                  使用8折券
                </el-button>
                <!-- <p v-if="item.productDuration > 1" style="color: red">
                  {{ item.productDuration }}个月仅需${{
                    handleDiscount(ids.id, item, (type = 'total'))
                  }}
                </p> -->
              </div>
            </li>
          </div>
        </template>

        <!-- 全球套餐 -->
        <template v-else>
          <div class="GRDC-list">
            <li v-for="item in bundleDataCptd.productList" :key="item.rackProductId">
              <!-- <div class="label" :style="{ background: ids.color }">{{ ids.name }}</div> -->
              <div class="top">
                <div class="name">
                  <p class="gb">
                    <span>{{ item.productName }}</span>
                    <b>{{ item.productTitle }}</b>
                    <strong>({{ item.bundleDuration }}天)</strong>
                  </p>
                  <p class="area">
                    {{ item.bundleContent && item.bundleContent[0].split('：')[0] }}：
                    <span>{{ item.bundleContent && item.bundleContent[0].split('：')[1] }}</span>
                  </p>
                </div>
                <div class="price">
                  <div>
                    <span>${{ item.totalPrice }}</span>
                    <!-- <strong>${{ item.totalPrice }}</strong> -->
                  </div>
                  <el-button @click="onSubmit(item, 1)">使用满减券</el-button>
                  <el-button class="btn-style" @click="onSubmit(item, 2)">使用8折券</el-button>
                </div>
              </div>
              <div class="bottom">
                <p>{{ item.bundleContent && item.bundleContent[1] }}</p>
              </div>
            </li>
          </div>
          <div class="areadesc">
            <ol v-for="item in bundleDataCptd.countries" :key="item">
              <span v-html="item.split('@')[0]"></span>
              <strong v-html="item.split('@')[1]"></strong>
            </ol>
          </div>
        </template>

        <div class="now">
          <img src="@/assets/images/visa/now.png" alt="" />
          <span>
            当前发售
            <b style="color: #d80000">2种优惠券</b>
            ，请以您购买的优惠券为准。
          </span>
        </div>
        <div class="tip">
          <p>迎客提醒：</p>
          <template v-if="activeCardType === 'USLC'">
            <li>
              <span>无限流量：</span>
              无限量套餐内含35GB 5G·4G
              LTE高速流量。高速流量用完后，我们依然保障基础流量服务不断档（128kbps）。
            </li>
            <li>
              <span>流量速度：</span>
              所有套餐5G·4G
              LTE流量用完后，将会转用基础流量（128kbps）。基础流量可用于浏览网页，使用微信，但可能无法支持浏览影片或下载文档等。5G·4G
              LTE的网络实现与您的手机制式相关。
            </li>
            <li>
              <span>无限中国通话：</span>
              免费中国大陆、香港、澳门、台湾（固话）地区国际通话。
            </li>
            <li>
              <span>三免服务：</span>
              免费三合一手机卡，中美免寄送费，免手续费。
            </li>
          </template>
          <template v-else>
            <li>
              <span>流量速度：</span>
              流量速度：漫游套餐里显示的流量均为
              5G·4GLTE流量，用完后将会转用基础流量（128kbps）。基础流量可用于浏览网页，使用微信，但可能无法支持浏览影片或下载文档等。5G·4GLTE的网络实现与您的手机制式相关，美国&加拿大国家除外。
            </li>
          </template>
        </div>
      </div>
    </div>

    <MessageBox
      textTitle="折扣码验证"
      ref="successDialog"
      yesBtnText="确定，下一步"
      :width="!isMobile ? '624px' : '80vw'"
      :height="!isMobile ? '300px' : '65.7333vw'"
      top="15vh"
      @dialogConfirm="handleRushBuy">
      <div slot="content" class="dialog-content">
        <el-form :model="form">
          <el-form-item label="折扣码">
            <el-input
              v-model="form.couponCode"
              placeholder="请填写您在“VISA购平台”领取的折扣码"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </MessageBox>
  </div>
</template>

<script>
import { aes } from '@/utils/cryptoApi';
import { checkCoupon } from '@/api/common';
import PopoverDiffGlobal from './PopoverDiffGlobal.vue';
import MessageBox from '@/components/MessageBox.vue';
export default {
  components: {
    PopoverDiffGlobal,
    MessageBox
  },
  props: {
    bundleList: {
      type: Array,
      require: true
    }
  },

  computed: {
    bundleDataCptd() {
      if (this.bundleList.length === 0) return [];
      // 美国=>时间类型/月份
      if (this.activeCardType === 'USLC') {
        const bundleData = this.bundleList.find((item) => item.position === 'rk-index-uslc-main');
        if (this.activeTime === 'rk_activity_10013_single') {
          return bundleData.productList.filter((v) => v.productDuration === 1).reverse();
        } else {
          return bundleData.productList
            .filter((v) => v.productDuration > 1)
            .filter((n) => n.productDuration === parseInt(this.activeMonth))
            .reverse();
        }
      }
      // 全球卡=>卡类型
      else {
        const type =
          this.activeTime === 'Physical SIM' ? 'rk-index-grdc-psim' : 'rk-index-grdc-esim';
        const bundleData = this.bundleList
          .filter((item) => item.position !== 'rk-index-uslc-main')
          .filter((v) => v.position === type);
        return bundleData[0];
      }
    },
    isMobile() {
      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      return flag;
    }
  },

  watch: {
    activeCardType: {
      handler(newVal) {
        newVal === 'USLC'
          ? (this.activeTime = 'rk_activity_10013_single')
          : (this.activeTime = 'Physical SIM');
        this.$emit('changeActiveCardType', newVal);
      }
    }
  },

  data() {
    return {
      // 卡类型
      cardTypeList: [
        {
          id: 1,
          name: '美国手机卡',
          value: 'USLC',
          imgUrl1: require('@/assets/images/visa/icon-usa-yes.svg'),
          imgUrl2: require('@/assets/images/visa/icon-usa-no.svg')
        },
        {
          id: 2,
          name: '全球数据漫游卡',
          value: 'GRDC',
          imgUrl1: require('@/assets/images/visa/icon-global-no.svg'),
          imgUrl2: require('@/assets/images/visa/icon-global-yes.svg')
        }
      ],
      activeCardType: 'USLC',
      // 卡时长
      timeTypeList: [
        { id: 1, name: '短期差旅', value: 'rk_activity_10013_single' },
        { id: 2, name: '长期居住', value: 'rk_activity_10013_multi' }
      ],
      simTypeList: [
        {
          id: 1,
          name: '实体手机卡<span class="font">（支持所有设备）</span>',
          value: 'Physical SIM'
        },
        { id: 2, name: 'eSIM手机卡<span class="font">（支持部分设备）</span>', value: 'ESIM' }
      ],
      activeTime: 'rk_activity_10013_single',
      monthList: ['3', '6', '12'],
      activeMonth: '3',

      // 选择套餐
      activeBundle: '',

      form: {
        couponCode: '',
        discountId: null
      },

      // 产品数据
      bundleData: {},
      activeItem: {},
      // 优惠类型
      discountType: [
        {
          id: 1,
          name: '立减$5券',
          color: '#D80000'
        },
        {
          id: 2,
          name: '8折优惠券',
          color: '#FFB741'
        }
      ]
    };
  },

  methods: {
    /**
     *
     * @param item 当前的套餐信息
     * @param id 选择是立减5元还是8折
     */
    onSubmit(item) {
      this.$refs.successDialog.init();
      this.activeItem = item;
    },
    async handleRushBuy() {
      if (!this.form.couponCode) {
        this.$refs.successDialog.init();
        return;
      }
      const res = await checkCoupon({ couponCode: this.form.couponCode, activityCode: 'AC_10015' });
      if (res.code !== '200') {
        this.form.couponCode = '';
        return;
      }
      // couponType   1 满减$5 2 折扣 3 满减$10
      this.form.discountId = res.data.couponType;

      const item = this.activeItem;
      const { cardItemType, productCode, rackProductId, esimType, productDuration, totalPrice } =
        item;
      if (!(cardItemType || productCode || rackProductId)) {
        return this.$message.warning('产品缺少参数！');
      }

      if (this.form.discountId === 3 && totalPrice < 100) {
        this.$alert('该产品不符合使用该券要求', '提示', {
          confirmButtonText: '确定',
          customClass: 'alert-box'
        });
        this.form.couponCode = '';
        return;
      }

      let params = {
        productCode,
        rackProductId,
        productDuration,
        couponCode: this.form.couponCode, // 折扣码
        discountId: this.form.discountId, // 优惠类型
        count: 1,
        autoNew: true,
        esimType, // 1/0? 'ESIM' : 'Physical SIM'
        cardType: cardItemType,
        activeCode: 'AC_10015'
      };
      // 国际漫游卡判断实体卡和esim卡
      if (this.activeTime === 'Physical SIM') {
        params.esimType = 0;
      } else if (this.activeTime === 'ESIM') {
        params.esimType = 1;
      }

      const urlParams = aes.encrypt(JSON.stringify(params));

      let platform = '';
      if (this.$router.history.current.fullPath.indexOf('platform=') !== -1) {
        platform = this.$router.history.current.query.platform || '';
      }

      // uslc https://www.encmobile.com/plans/2GB-plan?rackProductId=327&recommendCode=
      // grdc https://www.encmobile.com/plans/global
      // const address = 'http://localhost:8082';
      const address = window.location.origin;

      if (cardItemType === 'USLC') {
        window.open(
          `${address}/plans/${item.bundleData}-plan?rackProductId=${rackProductId}&couponCode=${
            this.form.couponCode
          }&recommendCode=&platform=${platform}&activityCode=AC_10015&routerParams=${encodeURIComponent(
            urlParams
          )}`,
          '_self'
        );
      } else {
        window.open(
          `${address}/plans/bundleForm?platform=${platform}&couponCode=${
            this.form.couponCode
          }&activityCode=AC_10015&routerParams=${encodeURIComponent(urlParams)}`,
          '_self'
        );
      }
    },
    /**
     * 计算折扣价格
     * @param {number} id - 1: 立减5元，2: 8折
     * @param {Object} item - 套餐信息
     * @param {string} type - 'total' 计算总价，'unit' 计算单价
     * @returns {string} 计算后的价格，保留两位小数
     */
    handleDiscount(id, item, type) {
      const isFixedDiscount = id === 1;
      const discountAmount = isFixedDiscount ? 5 : 0.8;

      if (type === 'total') {
        return isFixedDiscount
          ? (item.totalPrice - discountAmount).toFixed(2)
          : (item.saleTotalPrice * discountAmount).toFixed(2);
      } else {
        return isFixedDiscount
          ? ((item.totalPrice - discountAmount) / item.productDuration).toFixed(2)
          : (item.saleUnitPrice * discountAmount).toFixed(2);
      }
    }
  }
};
</script>
<style scoped lang="less">
@import './style/PackageInfo.less';
</style>
